import {Stack} from '@mui/material'
import {useNavigate} from 'react-router-dom'
import Label from '../../app/modules/customTable/Label'
import MainBtn from '../../app/modules/customTable/MainBtn'

export default function ServiceFeesSuspensionBanner() {
  const navigate = useNavigate()

  return (
    <Stack mb='20px' bgcolor={'#FBE8E9'} p='20px' gap='12px' alignItems='center'>
      <Label
        fs='17'
        fw='600'
        align='center'
        color='#405189'
        text={'store_suspended_service_fees'}
      />
      <MainBtn
        width='auto'
        bgcolor='#f16645'
        text='pay_service_fees'
        handelSubmit={() => navigate('/wallet/service-fees')}
      />
    </Stack>
  )
}
